import { memo } from 'react';

const Loading = () => {
  return (
    <div className={'loaderContainer'}>
      <div className={'loader'}></div>
    </div>
  );
};

export default memo(Loading);
